import React from 'react';
import BasicTablesContainer from '../../Componant/Tables/Reactstrap/BasicTable';

const ReactstrapTable = () => {
  return (
    <div className='page-body'>
      <BasicTablesContainer />
    </div>
  );
};

export default ReactstrapTable;
